import React from "react";
import LandingPopUpModal from "./LandingPopUpModal";

function LandingSessionBody() {
  return (
    <div className="pm-wrap">
      <div className="popup-modal">
        <LandingPopUpModal setShow={() => null} />
      </div>
    </div>
  );
}

export default LandingSessionBody;
